import { makeStyles } from '@material-ui/core/styles'
import { ALIGN } from '@v4/constants/quiz'

const useStyles = makeStyles(
	theme => ({
		text: {
			textAlign: ({ align }) => {
				const isRtl = theme.direction === 'rtl'

				return isRtl && align !== ALIGN.CENTER ? 'right' : null
			},
		},
	}),
	{
		name: 'Instructions',
	},
)

export default useStyles
